// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"9c869784","21":"1ba9c647","146":"4ccfed77","506":"dfa0a835","511":"331484e7","672":"2f8b2373","676":"3c412b8c","741":"a74e9bde","775":"17eeaa08"}[chunkId] + ".chunk.css";
};